import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DefaultTheme } from 'themes/interfaces/default-theme.interfaces';
import clsx from 'clsx';

const makeClasses = makeStyles<DefaultTheme>(theme => ({
  root: {
    ...theme.mixins.fonts.medium.xs,
  },
}));

export const Bold: React.FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>> = (props) => {
  const classes = makeClasses();
  return (
    <b
      {...props}
      className={clsx(classes.root, props.className)}
    />
  );
};
